import React, { useEffect, useState } from "react";
import "../styling/register.css";
import API from "../utils/api";
import { FaUserCircle } from "react-icons/fa";
import FlashMessage from "../components/FlashMessage";
import LoadingMask from "../components/LoadingMask.js";
import { useNavigate } from "react-router-dom";
const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [flashMessage, setFlashMessage] = useState("");
  const [flashType, setFlashType] = useState("success");
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (formData.password !== formData.confirmPassword) {
      setLoading(false);
      setFlashType("error");
      setFlashMessage("Password Mismatch !");
      return;
    }

    try {
      // ✅ API call to backend register route
      const res = await API.post(
        "auth/register", // change to your backend URL when deployed
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          password: formData.password,
        }
      );

      // ✅ Save token & user info
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      setFlashType("success");
      setFlashMessage("User created Successfully !");
      setFormData({
        name: "",
        phone: "",
        email: "",
        password: "",
        confirmPassword: "",
      });
      setTimeout(() => {
        navigate("/register");
      }, 1500);
    } catch (err) {
      setFlashType("error");
      setFlashMessage("sorry failed to create user  !");
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <FlashMessage
        message={flashMessage}
        type={flashType}
        duration={3000}
        onClose={() => setFlashMessage("")}
      />
      {loading && <LoadingMask text="Please wait..." />}
      <div className="register-card">
        <h2>Create Account</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
          <button
            className="btn btn-primary btn-block"
            type="submit"
            disabled={loading}
          >
            <FaUserCircle />
            <span>{loading ? "Registering..." : "Register"}</span>
          </button>
        </form>

        <p className="login-link">
          Already have an account? <a href="/login">Login</a>
        </p>
      </div>
    </div>
  );
};

export default Register;
